import { CustomerPartNumber } from "@auer-steel/Services/AuerSteelApiModels";
import { deleteCustomerPartNumber as deleteApi } from "@auer-steel/Services/CustomerPartNumberService";
import { AuerActions } from "@auer-steel/Store/AuerState";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = ApiHandler<CustomerPartNumber, {}, DispatchProp<AuerActions>>;

export const ExecuteHandler: HandlerType = async props => {
    await deleteApi(props.parameter);
    props.dispatch({
        type: "Data/CustomerPartNumbers/Reset",
    });
};

export const chain = [ExecuteHandler];

const deleteCustomerPartNumber = createHandlerChainRunner(chain, "DeleteCustomerPartNumber");
export default deleteCustomerPartNumber;
